import { render, staticRenderFns } from "./ManualEditOrderStatus.vue?vue&type=template&id=4bf0a478&scoped=true&"
import script from "./ManualEditOrderStatus.vue?vue&type=script&lang=js&"
export * from "./ManualEditOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./ManualEditOrderStatus.vue?vue&type=style&index=0&id=4bf0a478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0a478",
  null
  
)

export default component.exports